<template>
  <AbaFiltro v-if="!loading" :titulo="titulo">
    <ValidationProvider rules="required" mode="eager" name="unimed">
      <!-- <unicom-autocomplete
        :mensagemErro="errors[0]"
        mostrarIconeExcluir
        colorPlaceholder="#9E9E9E"
        placeholder="Tipo de prestador"
        v-model="objetoFiltro.tipoPrestador.descricao"
        @index="
          index => selecionarChave(index, 'tipoPrestador', listaTipoPrestador)
        "
        :items="listaTipoPrestador.map(e => e.descricao)"
      /> -->
      <div class="form-control__datas">
        <unicom-campo-calendario-v3
          class="competencia"
          fecharClique
          regrasValidacao="required|validacaoData"
          :duploClique="false"
          v-model="objetoFiltro.dataInicio"
          placeHolder="Data de Inicio"
          mostrarIconeExcluir
          :componentesAtivos="['Dias', 'Meses', 'Anos']"
        />
      </div>
      <div class="form-control__datas">
        <unicom-campo-calendario-v3
          class="competencia"
          fecharClique
          regrasValidacao="required|validacaoData"
          :duploClique="false"
          v-model="objetoFiltro.dataFim"
          placeHolder="Data Fim"
          mostrarIconeExcluir
          :componentesAtivos="['Dias', 'Meses', 'Anos']"
        />
      </div>
    </ValidationProvider>
    <template slot="botao">
      <unicom-botao
        :desabilitado="!habilitado"
        @click="proximaAba"
        :largura="360"
        :altura="40"
      >
        CONTINUAR
      </unicom-botao>
    </template>
  </AbaFiltro>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaFiltroMixin from "../AbaFiltroMixin";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  mixins: [AbasMixin, AbaFiltroMixin],
  data() {
    let listaTipoPrestador = [];

    return {
      listaTipoPrestador
    };
  },
  beforeMount() {
    // this.inicializarTipoPrestador();
  },
  methods: {
    // inicializarTipoPrestador() {
    //   this.loading = true;
    //   this.sleep(500).finally(() => {
    //     this.getListaTipoPrestadores()
    //       .then(res => {
    //         this.listaTipoPrestador = res.data;
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    //   });
    // }
  }
};
</script>

<style scoped>
.form-control__datas {
  margin: 1rem 0;
}
.form-control__datas > .competencia {
  margin-top: 0.5rem;
}
</style>
